<template>
  <div>
    <v-button @click.native="toggleFollow" tagelement="button" md primary iconLeft :hollow="isFollowing" id="step1">
      <icon :is="(isFollowing) ? 'account-minus-icon' : 'account-plus-icon'"></icon>
      {{ (isFollowing) ? 'Patiënt ontvolgen' : 'Patiënt volgen' }}
    </v-button>
    <generic-modal v-if="showFollowModal">
      <template #header>
        {{followUnFollowPatient.Follow.Header}}
      </template>
      <template #body>
        <p>{{followUnFollowPatient.Follow.Text}}</p>
      </template>
      <template #footer>
        <div class="modal-checkbox">
          <v-checkbox-group class="checkbox-group" label="Laat dit bericht niet meer zien" inputid="rememnerFollowPatient" @input="changeRememberFollowPatient( ...arguments)"></v-checkbox-group>
        </div>
        <v-button tagelement="button" md primary @click.native="closeModal" id="step2">Ik begrijp het</v-button>
      </template>  
    </generic-modal>
    <generic-modal :hasCloseButton="true" v-if="showUnfollowModal" @close="closeModal">
      <template #header>
        {{followUnFollowPatient.UnFollow.Header}}
      </template>
      <template #body>
        <p>{{followUnFollowPatient.UnFollow.Text}}</p>
      </template>
      <template #footer>
        <v-button tagelement="button" md hollow transparent @click.native="closeModal">Annuleren</v-button>
        <v-button tagelement="button" md primary @click.native="toggleFollow01">Patiënt toch ontvolgen</v-button>
      </template>  
    </generic-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import accountPlusIcon from 'icons/AccountPlus'
import accountMinusIcon from 'icons/AccountMinus'
import VParagraph from '@/components/shared/Paragraph.vue'
import VOverlay from '@/components/shared/Overlay.vue'
import VHeading from '@/components/shared/Heading.vue'
import VCheckboxGroup from '@/components/shared/form/CheckboxGroup'
import store from '@/store'
import router from '@/router'
import 'intro.js/minified/introjs.min.css'
import introJs from 'intro.js'
import GenericModal from '@/components/shared/GenericModal'

export default {
  name: 'patient-follow',
  components: {
    VHeading,
    accountPlusIcon,
    accountMinusIcon,
    VParagraph,
    VOverlay,
    VCheckboxGroup,
    GenericModal
  },
  props: {
    isFollowing: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      showFollowModal: false,
      showUnfollowModal: false,
      intro: introJs()
    }
  },
  created () {
    const self = this
    if (store.state.navigation.demo && store.state.navigation.demoActivated & store.state.navigation.demoFlow.patientFollow) {
      setTimeout(() => {
        this.intro.setOptions({
          steps: [
            {element: '#step1', intro: 'Wanneer je een nieuwe patiënt opzoekt of aanmaakt, volg je deze nog niet automatisch. Als je dit wel wilt, klik dan op de ‘Patiënt volgen’ knop.', position: 'right'}
          ],
          exitOnEsc: false,
          exitOnOverlayClick: false,
          skipLabel: 'Overslaan',
          nextLabel: 'Volgende >',
          prevLabel: '< Terug',
          doneLabel: 'Okey, begrepen'
        })
        this.intro.start().oncomplete(function () {
          self.toggleFollow()
        })
        window.scrollTo(0, 0)
      }, 1500)
    }
  },
  computed: {
    // VueJs store map getters to fetch store data
    ...mapGetters({
      patientFollow: 'patient/getPatientFollow',
      followUnFollowPatient: 'patient/getFollowUnFollowPatient'
    })
  },
  methods: {
    ...mapActions({
      set: 'patient/setPatientFollowStatus'
    }),
    closeModal () {
      this.showFollowModal = false
      this.showUnfollowModal = false
    },
    toggleFollow01 () {
      const data = { Follow: !this.isFollowing }
      this.showUnfollowModal = false
      this.set(data)
      if (store.state.navigation.demo && store.state.navigation.demoActivated) {
        this.intro.exit()
        store.commit('navigation/setDemoFlowStatus', {key: 'patientFollow', value: false})
        store.commit('navigation/setDemoFlowStatus', {key: 'patientListing', value: true})
        store.commit('navigation/setDemoFlowStatus', {key: 'createLicense', value: true})
        store.commit('navigation/setDemoFlowStatus', {key: 'createLicenseTwoColumn', value: true})
        router.push('/mijnpatienten/' + store.state.patient.patientGegevens.Achternaam.charAt(0).toLowerCase())
      }
    },
    toggleFollow () {
      const data = { Follow: !this.isFollowing }
      if (!this.isFollowing) {
        if (!this.patientFollow) {
          this.showFollowModal = true
        }
        this.set(data)
      } else {
        this.showUnfollowModal = true
      }
      if (store.state.navigation.demo && store.state.navigation.demoActivated) {
        this.intro.exit()
        store.commit('navigation/setDemoFlowStatus', {key: 'patientFollow', value: false})
        store.commit('navigation/setDemoFlowStatus', {key: 'patientListing', value: true})
        store.commit('navigation/setDemoFlowStatus', {key: 'createLicense', value: true})
        store.commit('navigation/setDemoFlowStatus', {key: 'createLicenseTwoColumn', value: true})
        router.push('/mijnpatienten/' + store.state.patient.patientGegevens.Achternaam.charAt(0).toLowerCase())
      }
    },
    /**
     * @function changeRememberFollowPatient -  Function to set remember patient follow service true or false based on user interaction
     * @param {boolean} - active
     */
    changeRememberFollowPatient (active) {
      store.commit('patient/setRememberPatientFollow', active)
    }
  }
}
</script>

<style lang="scss" scoped>
  .checkbox-group {
    display: flex;
    align-items: center;
  }

  .modal-checkbox {
    display: flex;
    vertical-align: middle;
    padding-right: 10px;
  }
</style>